import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Palette } from 'lucide-react';
import Logo from './Logo';
import './Navbar.css';

function Navbar({ onOpenThemePicker }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const scrollToDownload = (e) => {
    e.preventDefault();
    const element = document.getElementById('download');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else if (location.pathname !== '/') {
      window.location.href = '/#download';
    }
  };

  const isBetaPage = location.pathname === '/beta' || location.pathname === '/beta/';

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <Logo size={40} />
          <span className="brand-text">{isBetaPage ? 'Audra Beta' : 'Audra Books'}</span>
        </Link>

        <button
          className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-links ${mobileMenuOpen ? 'open' : ''}`}>
          {isBetaPage ? (
            <>
              <Link to="/downloads">
                Check for Updates
              </Link>
              <a
                href="https://forms.gle/nnRfuQb6XkknyecY6"
                target="_blank"
                rel="noopener noreferrer"
              >
                Submit Feedback
              </a>
              <a
                href="https://github.com/RandallEric/AudraBooks-Feedback/issues"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-download-btn"
              >
                GitHub Issues
              </a>
            </>
          ) : (
            <>
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                Home
              </Link>
              <Link to="/features" className={location.pathname === '/features' ? 'active' : ''}>
                Features
              </Link>
              <Link to="/beta" className={location.pathname === '/beta' || location.pathname === '/beta/' ? 'active' : ''}>
                Release Notes
              </Link>
              <button className="nav-theme-btn" onClick={onOpenThemePicker}>
                <Palette size={18} />
                <span>Theme</span>
              </button>
              <a href="#download" onClick={scrollToDownload} className="nav-download-btn">
                Download
              </a>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
